import type { CentreData } from './types';

export const riverstoneData: CentreData = {
  slug: 'riverstone',
  name: 'Schoolola Riverstone',
  suburb: 'Riverstone',
  region: 'Western Sydney',
  state: 'NSW',
  stateName: 'New South Wales',
  status: 'operational',
  yearLevels: 'Kindergarten - Year 8',
  canonicalPath: '/centres/riverstone/',
  heroImage: 'https://schoolola.com.au/centres/riverstone-og.jpg',
  address: {
    street: 'Suite 1/56 Garfield Rd E',
    city: 'Riverstone',
    postcode: '2765',
    lat: -33.6789,
    lng: 150.8667,
  },
  contact: {
    phone: '0480 472 883',
    phoneHref: '+61480472883',
    email: 'riverstone@schoololatutoring.com.au',
  },
  hours: {
    monday: { opens: '16:00', closes: '20:00' },
    tuesday: { opens: '16:00', closes: '20:00' },
    wednesday: null,
    thursday: { opens: '16:00', closes: '20:00' },
    friday: { opens: '16:00', closes: '20:00' },
    saturday: { opens: '09:00', closes: '13:00' },
    sunday: null,
  },
  heroSubtitle:
    'OC, selective school and NAPLAN preparation by qualified NSW Curriculum teachers using the proven TMRW™ methodology.',
  trustStrip: [
    { k: 'In-person', v: 'Suite 1/56 Garfield Rd E' },
    { k: 'Kindergarten - Year 8', v: 'All primary year levels' },
    { k: 'NSW Curriculum', v: 'Qualified teachers' },
  ],
  breadcrumb: { regionLabel: 'Western Sydney' },
  googleRating: {
    value: 5.0,
    count: 39,
    profileUrl: 'https://www.google.com/search?q=Schoolola+Riverstone',
  },
  reviews: [
    {
      author: 'Amirul Hakim',
      rating: 5,
      timeAgo: '5 months ago',
      datePublished: '2025-12-29',
      body: "I extremely happy with Schoolola Riverstone. The coaching is high quality, and the personalised support has made a strong impact on my child's progress. The teacher explains clearly, teaches patiently, and always helps when my kids need extra support.",
    },
    {
      author: 'Priyanka Reddy',
      rating: 5,
      timeAgo: '3 months ago',
      datePublished: '2026-02-28',
      body: 'The Schoolola school holiday programme was excellent. The tutors were knowledgeable and supportive, and the lessons were well structured and focused on selective exam skills. My child gained confidence and benefited greatly from the programme. Highly recommended.',
    },
    {
      author: 'dilip perina',
      rating: 5,
      timeAgo: '6 months ago',
      datePublished: '2025-11-29',
      isLocalGuide: true,
      body: "When we were looking for guidance regarding the Selective and OC entrance tests, we came across Schoolola and met Ravi. He was kind, professional, and patient, taking the time to understand our needs. He conducted our children's initial assessment with care.",
    },
    {
      author: 'Mohan Noone',
      rating: 5,
      timeAgo: '6 months ago',
      datePublished: '2025-11-29',
      body: 'My daughter attended this tuition centre for her OC preparation and we had a great experience. The teachers are very good and explain concepts clearly, which really helped her. The management is also flexible and easy to work with.',
    },
    {
      author: 'Gowrikaran Rathakrishnan',
      rating: 5,
      timeAgo: '8 months ago',
      datePublished: '2025-09-29',
      body: "My son has been attending Maths and English tutoring at Schoolola Riverstone for almost a year now, and the progress has been amazing. The tutors are patient, professional, and make learning fun. His confidence has grown a lot, and we are very happy with the support he's received. Highly recommended!",
    },
    {
      author: 'Padma1 1328',
      rating: 5,
      timeAgo: '6 months ago',
      datePublished: '2025-11-29',
      body: 'Schoolola Tutoring has been amazing for my child! The teachers are patient, skilled, and genuinely care about student progress. I definitely recommend Schoolola to any parent looking for quality tutoring.',
    },
    {
      author: 'Meenaxi Pandey',
      rating: 5,
      timeAgo: '10 months ago',
      datePublished: '2025-07-29',
      body: 'We had a fantastic experience with Schoolola Riverstone. The service is excellent and the staff are absolutely wonderful. My kid always looked forward to their sessions and felt excited to learn each day. The teachers are very supportive.',
    },
    {
      author: 'Vasaa Krish',
      rating: 5,
      timeAgo: '6 months ago',
      datePublished: '2025-11-29',
      isLocalGuide: true,
      body: "Schoolola's TMRW course structure is genuinely impressive - clear, engaging and very well thought out. We also appreciated the free practice exams for selective and OC students; the SCOPE exams were especially helpful.",
    },
    {
      author: 'Jyothi Kumari',
      rating: 5,
      timeAgo: '10 months ago',
      datePublished: '2025-07-29',
      body: "We've had an excellent experience with Riverstone Schoolola over the past few months. The tutor is not only highly knowledgeable but also patient, encouraging, and genuinely invested in my child's progress. I've seen a noticeable improvement.",
    },
    {
      author: 'Anitha Rosalin',
      rating: 5,
      timeAgo: '8 months ago',
      datePublished: '2025-09-29',
      isLocalGuide: true,
      body: "A big thank you to Ravi Chatty and the team at Schoolola Riverstone! We didn't opt for any other tuition during Year 3 and 4, except for the Boot Camp at Schoolola, Riverstone. Their syllabus was challenging, but it made the O.C. exam manageable.",
    },
    {
      author: 'Raghuram Puvvada',
      rating: 5,
      timeAgo: 'a year ago',
      datePublished: '2025-05-29',
      isLocalGuide: true,
      body: "I recently enrolled my child in the Schoolola Kids Training Centre Riverstone, and I can confidently say it's been an exceptional experience! The training programme is a perfect blend of the right material and a keen focus on details.",
    },
    {
      author: 'Dasaradhy Srinivasan',
      rating: 5,
      timeAgo: '10 months ago',
      datePublished: '2025-07-29',
      body: "My son attended the Selective Trial Test Bootcamp at Schoolola Riverstone and we found the sessions very useful to understand his areas of improvement. The tests were well structured and the feedback and guidance we received at the end of the sessions definitely helped to boost my son's confidence before taking the real tests.",
    },
    {
      author: 'shaher basheer',
      rating: 5,
      timeAgo: '10 months ago',
      datePublished: '2025-07-29',
      isLocalGuide: true,
      body: "We are extremely happy with our experience at Schoolola Riverstone. The coaching provided is of a very high standard, and the personalised tutoring has made a significant difference in my child's learning journey.",
    },
    {
      author: 'Kumar G',
      rating: 5,
      timeAgo: 'a year ago',
      datePublished: '2025-05-29',
      body: 'I am so grateful for sending my son to Schoolola Tutoring Riverstone. The tutors are incredibly knowledgeable and patient, and they have made a noticeable difference in his English and Maths skills. They take the time to explain concepts clearly.',
    },
    {
      author: 'Abhishek Jp',
      rating: 5,
      timeAgo: '9 months ago',
      datePublished: '2025-08-29',
      body: 'We are having very good experience with Schoolola. My son joined here last term and has been enjoying his learning.',
    },
    {
      author: 'Abiuda Reddy',
      rating: 5,
      timeAgo: 'a year ago',
      datePublished: '2025-05-29',
      body: 'Started sending my kid from Term 1 this year. Study material and concept-oriented teaching method was very good. My child focus on learning has improved with understanding importance of subjects now.',
    },
    {
      author: 'Muralikrishna Munukoti',
      rating: 5,
      timeAgo: '8 months ago',
      datePublished: '2025-09-29',
      body: 'The Selective Holiday Camp were run very well and my son certainly benefitted from it which led to a successful offer.',
    },
    {
      author: 'Sumanth Panta',
      rating: 5,
      timeAgo: '6 months ago',
      datePublished: '2025-11-29',
      body: 'Excellent tutoring services, highly recommended. My son enjoyed going to tuitions.',
    },
    {
      author: 'praneeth kumar',
      rating: 5,
      timeAgo: '6 months ago',
      datePublished: '2025-11-29',
      body: 'The management and tutor are great. My child loves to attend the classes.',
    },
    {
      author: 'Alok Kumar',
      rating: 5,
      timeAgo: '6 months ago',
      datePublished: '2025-11-29',
      isLocalGuide: true,
      body: 'Nice coaching institute in vicinity for kids. Ravi and the management team are excellent.',
    },
    {
      author: 'Zeniroz',
      rating: 5,
      timeAgo: '10 months ago',
      datePublished: '2025-07-29',
      isLocalGuide: true,
      body: "We've had a great experience so far. I think, best tutor around this area. We've already started seeing solid results. Happy!",
    },
    {
      author: 'Niranjhani Vasudevan',
      rating: 5,
      timeAgo: '6 months ago',
      datePublished: '2025-11-29',
      body: 'Great to have reliable tutoring service in the community.',
    },
    {
      author: 'Raju Ramagiri',
      rating: 5,
      timeAgo: 'a year ago',
      datePublished: '2025-05-29',
      body: 'Good environment, skilled tutors and good study materials.',
    },
    {
      author: 'Ganesh Kaveripakkam Gandhi',
      rating: 5,
      timeAgo: '4 weeks ago',
      datePublished: '2026-05-01',
      body: 'Schoolola provides an exceptionally supportive learning environment with expert tutors and top-notch materials that truly set students up for success.',
    },
    {
      author: 'Kiran Macherla',
      rating: 5,
      timeAgo: '4 weeks ago',
      datePublished: '2026-05-01',
      isLocalGuide: true,
      body: 'This centre is highly commendable. Its location offers excellent accessibility, and the staff are both proficient and amiable, demonstrating a clear understanding of student inquiries and patiently providing clarification.',
    },
    {
      author: 'rahul d',
      rating: 5,
      timeAgo: 'a month ago',
      datePublished: '2026-04-29',
      body: 'Good location for us and convenient. Course material is good. Staff and tutors are really helpful and listen to our concerns and try to address them.',
    },
    {
      author: 'Anusha Evi',
      rating: 5,
      timeAgo: 'a month ago',
      datePublished: '2026-04-29',
      body: "I've had a wonderful experience with Schoolola Riverstone Tutoring. The teachers are caring, patient, and take the time to understand my child's individual learning needs. I've seen a noticeable improvement in my child's confidence.",
    },
    {
      author: 'Adi Battini',
      rating: 5,
      timeAgo: 'a month ago',
      datePublished: '2026-04-29',
      isLocalGuide: true,
      body: "We have had a truly wonderful experience with Schoolola over the past year and a half. During this time, I've seen immense improvement in my son's academics, along with a noticeable boost in his interest and enthusiasm towards learning.",
    },
    {
      author: 'Danny Pulickal',
      rating: 5,
      timeAgo: 'a month ago',
      datePublished: '2026-04-29',
      body: "Our daughter really loved learning at Schoolola Riverstone during the summer break boot camp and the first term. She's gotten better in all her subjects. The tutors are super patient when they explain things to the kids.",
    },
    {
      author: 'Prashant Sharma',
      rating: 5,
      timeAgo: 'a month ago',
      datePublished: '2026-04-29',
      body: 'Thanks to Ravi and Team setting good academic foundation, with a structured learning approach.',
    },
    {
      author: 'Bhanu Prakash',
      rating: 5,
      timeAgo: 'a month ago',
      datePublished: '2026-04-29',
      isLocalGuide: true,
      body: 'The teachers are knowledgeable, friendly, and really help students understand tough subjects easily.',
    },
    {
      author: 'Suba raman',
      rating: 5,
      timeAgo: 'a month ago',
      datePublished: '2026-04-29',
      isLocalGuide: true,
      body: 'Schoolola tutoring is very good. Their practice and home work sheets are very good and align with curriculum.',
    },
    {
      author: 'kishore reddy mannem',
      rating: 5,
      timeAgo: '4 weeks ago',
      datePublished: '2026-05-01',
      isLocalGuide: true,
      body: 'Excellent tutoring centre with dedicated teachers and a great learning environment for our children.',
    },
    {
      author: 'Deepak K',
      rating: 5,
      timeAgo: '6 months ago',
      datePublished: '2025-11-29',
      body: 'Highly recommend Schoolola Riverstone. The teachers are supportive and the programme is well structured.',
    },
    {
      author: 'manju vani',
      rating: 5,
      timeAgo: 'a year ago',
      datePublished: '2025-05-29',
      body: 'Great experience for our child at Schoolola Riverstone. Friendly staff and excellent teaching methodology.',
    },
  ],
  suburbsServed: ['Riverstone', 'Schofields', 'Grantham Farms', 'Vineyard'],
  programs: [
    {
      id: 'oc',
      title: 'OC TMRW™ Preparation',
      yearPill: { label: 'Yr 3 - 4', tone: 'info' },
      tagline: 'Comprehensive OC exam preparation with proven TMRW™ strategies',
      bullets: ['Thinking Skills', 'Mathematical Reasoning', 'Reading'],
      educationalLevel: 'Year 3 to Year 4',
      description: 'Comprehensive OC exam preparation for primary students using the proven TMRW™ methodology, with practice tests and structured strategy training.',
      featured: 'popular',
    },
    {
      id: 'selective',
      title: 'Selective TMRW™ Preparation',
      yearPill: { label: 'Yr 5 - 6', tone: 'info' },
      tagline: 'Expert coaching for selective school entrance examinations',
      bullets: ['Thinking Skills', 'Mathematical Reasoning', 'Reading', 'Writing'],
      educationalLevel: 'Year 5 to Year 6',
      description: 'Expert coaching for selective school entrance examinations, specialised for primary students using the TMRW™ methodology.',
    },
    {
      id: 'foundations',
      title: 'Foundations Course',
      yearPill: { label: 'K - Year 8', tone: 'success' },
      tagline: 'Core English and maths · all primary year levels',
      bullets: ['Phonics, fluency, comprehension', 'Number sense to fractions', 'Writing structure across genres'],
      educationalLevel: 'Kindergarten to Year 8',
      description: 'Core English and mathematics tutoring for Kindergarten through Year 8 students, aligned to the NSW Curriculum.',
    },
    {
      id: 'naplan',
      title: 'NAPLAN Preparation',
      yearPill: { label: 'Yr 3, 5', tone: 'info' },
      tagline: '10-week term aligned to ACARA',
      bullets: ['Reading and writing', 'Numeracy strategies', 'Language conventions'],
      educationalLevel: 'Year 3 and Year 5',
      description: '10-week term NAPLAN preparation course covering reading, writing, language conventions and numeracy, aligned to ACARA test specifications.',
    },
  ],
  differentiators: [
    {
      title: 'NSW Curriculum specialists',
      body: "Lessons map to what your child's school actually teaches, not generic worksheets.",
      icon: 'BookOpen',
    },
    {
      title: 'Measurable progress reports',
      body: 'Regular assessments tracked against ACARA bands.',
      icon: 'LineChart',
    },
    {
      title: 'Small group ratios',
      body: 'Small group sizes for genuine individual attention while keeping the energy of peer learning.',
      icon: 'Users',
    },
    {
      title: 'OC and Selective track record',
      body: 'Students placed at Blacktown Boys High, Penrith High and other Western Sydney selective schools.',
      icon: 'Trophy',
    },
  ],
  faqs: [
    {
      question: 'What year levels do you tutor in Riverstone?',
      answer: 'Kindergarten through Year 8. Foundations covers all primary year levels in English and maths; OC, Selective and NAPLAN programmes target specific testing years.',
    },
    {
      question: 'Where is the Riverstone centre located?',
      answer: 'Schoolola Riverstone operates from Suite 1/56 Garfield Rd E, Riverstone NSW 2765.',
    },
    {
      question: 'What are your operating hours in Riverstone?',
      answer: 'Monday, Tuesday, Thursday and Friday from 4:00 PM to 8:00 PM, and Saturday from 9:00 AM to 1:00 PM. Closed Wednesday and Sunday.',
    },
    {
      question: 'What does the free assessment include?',
      answer: 'A full diagnostic assessment, a 1:1 parent consultation, and a written learning plan with the recommended programme.',
    },
  ],
};
